module.exports = __webpack_public_path__ + "static/media/playMarket.b7269f5f.png";